import React, { Component }          from 'react';
import { PanelCorner }               from 'components/panel';
import color                         from 'components/color';


const panelStyle = {
  minHeight       : '100vh',
  width           : '100%',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  
  backgroundColor : color.blue,
  color           : color.white,
};  

// 
// const panelCornerStyle = {
// 
// 
// };  

class Panel extends Component {  
  render() {    
    return (
      <div className="panel" style={ panelStyle }>
        
        {/* <PanelCorner>{ this.props.topleft }</PanelCorner>
        <PanelCorner>{ this.props.topRight }</PanelCorner>
        <PanelCorner>{ this.props.bottomleft }</PanelCorner>
        <PanelCorner>{ this.props.bottomRight }</PanelCorner> */}
        
        { this.props.children }
        
      </div>
    );
  }
}

export default Panel;



// WEBPACK FOOTER //
// ./src/components/panel/panel.js